import { inject } from 'mobx-react';
import * as React from 'react';

import { PropertyShortlist } from '@shared-ui/lodging-property-details';
import { ShortlistToggleProvider } from '@shared-ui/trip-planning-travelpulse';
import { useLocalization } from '@shared-ui/localization-context';

import { UIPageStore } from 'src/common/stores/ui-page-store';

import { Level, liveAnnounce } from 'uitk-react-utils';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const ShortlistWrapper: React.FC<SharedUiWrapperProps & { uiPage?: UIPageStore }> = inject('uiPage')(({ inputs, uiPage }) => {
  const { formatText } = useLocalization();

  /**
   * @vdorsonnens [30/04/21]
   * We need to override the global shortlist provider (src/common/components/common/shortlist/shortlist-provider.tsx)
   * temporarily until I get the full toast message to be returned from the spinner. Currently the shared-ui component only
   * dispatches the propertyName.
   */
  const handler = (message: any) => {
    const notification = formatText('hotels.shortlist.saveToList.notification', message);

    uiPage?.showNotification(notification);
    liveAnnounce(notification, Level.POLITE);
  };

  return (
    <ShortlistToggleProvider dispatchHandler={handler}>
      <PropertyShortlist inputs={inputs} />
    </ShortlistToggleProvider>
  );
});

export const SharedUiShortlistWrapper = withSharedUiPropertyDetails(ShortlistWrapper);
SharedUiShortlistWrapper.displayName = 'SharedUiShortlistWrapper';
